import { Navigate, Outlet, useLocation } from "react-router-dom";
import LocalStorageKey from "../../enums/LocalStorageKey";
import Role from "../../enums/Role";

/**
 * 권한별 접근 허용 경로.
 * GNB 메뉴(ContentWrapperMenuItems)에 노출되는 경로를 그대로 따른다. — 메뉴에 없는 화면은 URL 직접 입력으로도 못 들어간다.
 *  - exact    : 정확히 일치해야 허용
 *  - prefixes : 하위 경로까지 허용 (메뉴에서 진입하는 상세 화면용. 예: 매장 목록 -> /shops/{storeId})
 *  - home     : 허용되지 않은 경로로 들어왔을 때 돌려보낼 기본 화면
 */
const ROLE_ROUTES = {
    [Role.Admin]: {
        exact: ["/", "/dashboard", "/franchises", "/shops", "/shops/map", "/users", "/settings"],
        prefixes: ["/shops/"],
        home: "/dashboard",
    },
    [Role.FranchiseManager]: {
        exact: [
            "/",
            "/dashboard",
            "/shops",
            "/shops/map",
            "/revenues",
            "/revenues/transactions",
            "/revenues/statistical",
            "/tickets",
            "/users",
        ],
        prefixes: ["/shops/"],
        home: "/dashboard",
    },
    [Role.CallCenter]: {
        exact: ["/", "/dashboard", "/shops", "/shops/map", "/tickets"],
        prefixes: ["/shops/"],
        home: "/dashboard",
    },
    [Role.StoreManager]: {
        exact: ["/shops", "/shops/map", "/revenues", "/revenues/transactions"],
        prefixes: ["/shops/"],
        home: "/shops",
    },
};

// role 이 없거나 알 수 없는 값이면 GNB 기본 메뉴와 동일하게 취급
const DEFAULT_ROUTES = ROLE_ROUTES[Role.FranchiseManager];

function isAllowed(pathname, routes) {
    if (routes.exact.includes(pathname)) return true;
    return routes.prefixes.some((prefix) => pathname.startsWith(prefix));
}

/**
 * 인증/인가 게이트. 라우트 레벨에서 렌더 전에 막는다.
 *  1) accessToken 없음        -> /auth/init
 *  2) role 에 없는 메뉴 경로  -> 해당 role 의 기본 화면
 */
function RequireAuth() {
    const { pathname } = useLocation();

    const accessToken = localStorage.getItem(LocalStorageKey.accessToken);
    if (!accessToken) {
        return <Navigate to={"/auth/init"} replace />;
    }

    const role = localStorage.getItem(LocalStorageKey.role);
    const routes = ROLE_ROUTES[role] ?? DEFAULT_ROUTES;

    if (!isAllowed(pathname, routes)) {
        return <Navigate to={routes.home} replace />;
    }

    return <Outlet />;
}

export default RequireAuth;
export { ROLE_ROUTES };
